import styled from "@emotion/styled"
import Box from "./Box"

const defaultSize = "60px"
const defaultLite = "#C9CFDD"
const defaultBrand = "#1199FA"

export const Spinner = styled(Box)<{
  size?: string
  lite?: string
  brand?: string
}>`
  width: ${props => props.size || defaultSize};
  height: ${props => props.size || defaultSize};
  display: inline-block;
  position: relative;
  color: ${props => props.lite || defaultLite};
  animation: rotation 1s linear infinite;

  &:after,
  &:before {
    content: "";
    position: absolute;
    width: calc(${props => props.size || defaultSize} / 2);
    height: calc(${props => props.size || defaultSize} / 2);
    top: 50%;
    left: 50%;
    transform: scale(0.5) translate(0, 0);
    background-color: ${props => props.lite || defaultLite};
    border-radius: 50%;
    animation: animloader38 1s infinite ease-in-out;
  }

  &:before {
    background-color: ${props => props.brand || defaultBrand};
    transform: scale(0.5)
      translate(
        -${props => props.size || defaultSize},
        -${props => props.size || defaultSize}
      );
  }

  @keyframes animloader38 {
    50% {
      transform: scale(1) translate(-50%, -50%);
    }
  }

  @keyframes rotation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`

export default Spinner
